var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.graphContainer},[_c('SummaryGraphHeader',{attrs:{"categories":_vm.categories,"item":_vm.item,"total":_vm.total,"totalText":_vm.totalText}}),_c('SummaryGraphContent',{attrs:{"categories":_vm.categories,"item":_vm.item,"total":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }